export var DiagnosticCode;
(function (DiagnosticCode) {
    DiagnosticCode[DiagnosticCode["UnsupportedSyntax"] = 110000] = "UnsupportedSyntax";
    DiagnosticCode[DiagnosticCode["UnknownType"] = 110001] = "UnknownType";
    DiagnosticCode[DiagnosticCode["UnknownSymbol"] = 110002] = "UnknownSymbol";
    DiagnosticCode[DiagnosticCode["InvalidBuiltinReference"] = 110003] = "InvalidBuiltinReference";
    DiagnosticCode[DiagnosticCode["InvalidBuiltinModify"] = 110004] = "InvalidBuiltinModify";
    DiagnosticCode[DiagnosticCode["InvalidBuiltinUsage"] = 110005] = "InvalidBuiltinUsage";
    DiagnosticCode[DiagnosticCode["InvalidBuiltinCall"] = 110006] = "InvalidBuiltinCall";
    DiagnosticCode[DiagnosticCode["InvalidContract"] = 110007] = "InvalidContract";
    DiagnosticCode[DiagnosticCode["InvalidContractEvent"] = 110008] = "InvalidContractEvent";
    DiagnosticCode[DiagnosticCode["InvalidContractProperties"] = 110009] = "InvalidContractProperties";
    DiagnosticCode[DiagnosticCode["InvalidContractMethod"] = 110010] = "InvalidContractMethod";
    DiagnosticCode[DiagnosticCode["InvalidContractType"] = 110011] = "InvalidContractType";
    DiagnosticCode[DiagnosticCode["InvalidContractStorageType"] = 110012] = "InvalidContractStorageType";
    DiagnosticCode[DiagnosticCode["InvalidContractNew"] = 110013] = "InvalidContractNew";
    DiagnosticCode[DiagnosticCode["UnknownCall"] = 110014] = "UnknownCall";
    DiagnosticCode[DiagnosticCode["InvalidSmartContractType"] = 110015] = "InvalidSmartContractType";
    DiagnosticCode[DiagnosticCode["InvalidNotifierType"] = 110016] = "InvalidNotifierType";
    DiagnosticCode[DiagnosticCode["InvalidLiteral"] = 110017] = "InvalidLiteral";
    DiagnosticCode[DiagnosticCode["Invariant"] = 110018] = "Invariant";
    DiagnosticCode[DiagnosticCode["MultipleSignatures"] = 110019] = "MultipleSignatures";
    DiagnosticCode[DiagnosticCode["UnknownModule"] = 110020] = "UnknownModule";
    DiagnosticCode[DiagnosticCode["ReferenceError"] = 110021] = "ReferenceError";
    DiagnosticCode[DiagnosticCode["InvalidLinkedSmartContract"] = 110022] = "InvalidLinkedSmartContract";
    DiagnosticCode[DiagnosticCode["InvalidCurrentTime"] = 110023] = "InvalidCurrentTime";
    DiagnosticCode[DiagnosticCode["InvalidSenderAddress"] = 110024] = "InvalidSenderAddress";
    DiagnosticCode[DiagnosticCode["InvalidStructuredStorageFor"] = 110025] = "InvalidStructuredStorageFor";
    DiagnosticCode[DiagnosticCode["SomethingWentWrong"] = 110026] = "SomethingWentWrong";
    DiagnosticCode[DiagnosticCode["InvalidContractProperty"] = 110027] = "InvalidContractProperty";
})(DiagnosticCode || (DiagnosticCode = {}));

//# sourceMappingURL=DiagnosticCode.js.map
